import { render } from "./TabAzienda.vue?vue&type=template&id=dbbf0454&scoped=true"
import script from "./TabAzienda.vue?vue&type=script&lang=js"
export * from "./TabAzienda.vue?vue&type=script&lang=js"

import "./TabAzienda.vue?vue&type=style&index=0&id=dbbf0454&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbbf0454"]])

export default __exports__